export const REGISTRATION_TEXT = {
  STEPS: {
    PERSONAL_PARTICULARS: 'Personal Particulars',
    WELCOME_LETTER: 'Welcome Letter',
    ONLINE_TRAINING: 'Online Training',
    STUDENT_CARD_BOOKING: 'Student Card Collection Booking',
  },
  NEXT_STEP: 'Next Step',
  CONFIRM_PERSONAL_DETAILS: 'Confirm Personal Details',
  UPLOAD_PHOTO: 'Upload Photo for Student Card',
  STUDENT_PHOTO: 'Student Photo',
  APPLICATION_NO: 'Application No.',
  OFFER_TO_YEAR: 'Offered To Year',
  OFFER_TO_SEM: 'Offered To Semester',
  PROG_CODE: 'Programme Code',
  PROG_SUBCODE: 'Programme Subcode',
  HKPFS_ID: 'HKPFS Ind',
  JOINT_INSTITUTION: 'Joint Phd Prog Partner University/Institution',
  DUAL_INSTITUTION: 'Dual Phd Prog Partner University/Institution',
  COLLAB_INSTITUTION: 'Collab Phd Prog Partner University/Institution', // Currently not used as term deprecated
  ENGLISH_SURNAME: 'Name In English Surname',
  ENGLISH_GIVENNAME: 'Name In English Given Name',
  CHINESE_NAME: 'Name In Chinese',
  EMAIL_ADDRESS: 'Email Address',
  DATE_OF_BIRTH: 'Date Of Birth',
  GENDER: 'Gender',
  NATIONALITY_REGION: 'Nationality Country Region',
  NATIONALITY_PROVINCE: 'Nationality Province',
  IDENTITY_TYPE: 'Identity Type',
  IDENTITY_NUMBER: 'Identity Number',
  RESIDENCE_TYPE: 'Residence Type',
  LOCAL_INDICATOR: 'Local Indicator',
  CONTACT_PHONE: 'Contact Phone',
  MOBILE_AREA_CODE: 'Mobile Area Code',
  MOBILE_NUMBER: 'Mobile Number',
  ADDRESS_LINE_1: 'Address Line 1',
  ADDRESS_LINE_2: 'Address Line 2',
  ADDRESS_LINE_3: 'Address Line 3',
  ADDRESS_COUNTRY_REGION: 'Address Country Region',
  DISABILITY_TYPE: 'Disability Type',
  DISABILITY_DETAIL: 'Disability Detail',
  STUDENT_NO: 'Student No.',

  PROCEED_TO_PROGRAMME_REGISTRATION: 'Proceed to Programme Registration',
  CONFIRM_PHOTO: 'Confirm Photo',
  REGISTER: 'Confirm Photo & Register',
  REGISTERED: 'You have completed your student record creation.',
  PHOTO_ALERT:
    'You have not uploaded any personal photos that meet the requirements.',
  REMARK:
    'Should the aforementioned information be inaccurate, please reach out to the <i>Graduate School</i> <a href="mailto:gs.it@polyu.edu.hk">(gs.it@polyu.edu.hk)</a> for assistance.',
};

export const registerHelperText = (toDate: string): string => `
<p>Please complete your Online Registration before ${toDate}.</p>
<p>If you are unable to complete your registration online within the scheduled period, please contact your 
<a href='https://www.polyu.edu.hk/education/faculties-schools-departments/' target="_blank" rel="noopener noreferrer">department</a> for assistance. Otherwise, your offer will lapse.</p>
<p>You can collect your student card at PolyU according to the schedule provided in the "Important Notes for Registered Students", which will be sent to you after you complete the program registration.</p>
`;

export const UPLOAD_PHOTO_TEXT = [
  `1. Please provide a recent color photo taken within the last 6 months to show your current look.`,
  `2. A plain, light-coloured background is ideal.`,
  `3. Face the camera with a neutral expression and eyes open.`,
  `4. Photo size: <i>200KB-600KB, JPG format.</i>`,
  `5. We appreciate your attention to these details for a seamless verification.`,
  `6. You can find the acceptable dimension in <a class="req-ref-link" target="_blank" href="https://www.polyu.edu.hk/aradm/eadmission/photograph_requirements.pdf" rel="noopener noreferrer">Photograph Requirements</a>`,
];

export const WELCOME_LETTER_TEXT = {
  STUDENT_NUMBER: 'Student Number: ',
  ACTIVATE_NET_ID: 'Activate Your PolyU Network Identity (NetID)',
  CHECK_EMAIL: 'Check Email and  Update Your Information',
  DOWNLOAD: 'Download PolyULife Now!',
  MANDATORY_ONLINE_TRAINING:
    'Mandatory Online Training Module on Preventing Sexual Harassment on Campus',
  MANDATORY_ANTI_DECEPTION: 'Mandatory Anti-deception Learning Kit',
  COLLECT_IDENTITY_CARD: 'Collect Your Student Identity Card',
  CHECK_INFORMATION: 'Check Important Information and Websites',
  ENROLMENT: 'Concurrent Enrolment',
  HEALTH_CARE: 'Health Care Services',
  ALUMNI_AFFAIR: 'Alumni Affairs Office (AAO)',
  NON_LOCAL_IDENTITY_CARD:
    'Hong Kong Identity Card (HKID) (for non-local students only)',
  DEAR_STUDENT: 'Dear Student,',
  WELCOME_INTRO: `To proceed, please click to enroll the `,
  ONLINE_TRAINING: 'Online Training module',
  AND: 'and finish the',
  KIT: 'Anti-deception Learning Kit',

  ACTIVATE_NET_ID_TEXT: `
    <p class = "text-bottom">You need to set up a PolyU Account to receive updates and to perform important 
    tasks such as subject registration. To activate your NetID, use the "NetID Registration" function in 
    the "PolyU Identity Portal (IdPortal)" at 
    <a target="_blank" rel="noopener noreferrer" href="https://www.polyu.edu.hk/netid">https://www.polyu.edu.hk/netid</a>. 
        <br /><br />
    You will need your student number (NetID), HKID/ Passport/ Mainland ID number and PolyU Programme Code, 
    and personal email for activation. Your personal email will also be used for self-service password resets.
        <br /><br />
    If you have any issues with activation, contact the Information Technology Services Office (ITS) hotline at 
    (852) 2766 5900, WhatsApp/ WeChat at (852) 6577 9669 or visit the IT HelpCentre at Room M201, Li Ka Shing Tower 
    for assistance during the following service hours:
        <br /><br />
    </p>
    <div class="row con_collapse">
    <div class="col-12">
      <div class="col-lg-12">
        <div class="table-responsive">
          <table class="table">
            <thead class="header_table text-center">
              <tr>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody class="text-center">
              <tr>
                <td>Monday to Friday</td>
                <td>8:30 a.m. - 7:00 p.m.</td>
              </tr>

              <tr>
                <td>Saturday</td>
                <td>9:00 a.m. - 12:00 noon</td>
              </tr>
              <tr>
                <td>Sunday &amp; Public Holidays</td>
                <td>Closed</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </div>

      <p>
          For more details about IT facilities and services available, you may visit <b>"IT Services for
              Students"</b> at <a href="https://www.polyu.edu.hk/its/students/it-services-for-students/"
              target="_blank" rel="noopener noreferrer">https://www.polyu.edu.hk/its/students/it-services-for-students/</a>.
          <br /><br />
      </p>
  `,
  CHECK_EMAIL_TEXT: `
    <p>Information regarding study and registration may be delivered by your department, lecturers/
      advisors and offices of the University, such as Academic Registry, Library, Information
      Technology Services Office and Student Affairs Office via PolyU Connect email. Hence, you need
      to check PolyU Connect email account regularly. Otherwise, you will miss important information
      related to study or activity.
      <br /><br />
      To access your PolyU Connect mail account, please go to <a
          rel="noopener noreferrer"
          href="https://www.polyu.edu.hk/connectmail "
          target="_blank">https://www.polyu.edu.hk/connectmail </a> and login with your
      <b>NetID@connect.polyu.hk</b> and <b>NetPassword</b>.
      <br /><br />
      To ensure you receive the latest information/ updates without delay, it is particularly
      important to keep your residential address, correspondence address and mobile phone number
      updated at all times during your study at the PolyU. If you are not living at home (e.g. staying
      in student hostel), please update your correspondence address to your place of residence in Hong
      Kong as soon as possible. You can update your address information via <a
          href="http://www.polyu.edu.hk/student " target="_blank">eStudent</a>.
      <br /><br />
      Given that the University may reach your next of kin (or parent/ guardian especially if you are
      under 18) when necessary (e.g. in the case of emergencies), please update such information now
      via <a href="http://www.polyu.edu.hk/student" target="_blank" rel="noopener noreferrer">eStudent</a> if it is not yet
      provided before.
  </p>
  `,
  DOWNLOAD_TEXT: `
    <p> PolyULife is now available on <a href="https://apps.apple.com/app/polyulife/id6444471174"
            target="_blank" rel="noopener noreferrer"><u>App Store</u></a> and <a
            href="https://play.google.com/store/apps/details?id=com.polyulife" target="_blank" rel="noopener noreferrer"><u>Google
                Play</u></a>. It has been tested and certified to support devices running iOS 13 or later,
        and Android 9 or later.You can login with your NetID to view your personal information.
    </p>
    <img src="https://www.polyu.edu.hk/aradm/prog_reg/Student_Mobile_App.jpg"
        alt="Download PolyULife Now!" />
  `,
  MANDATORY_ONLINE_TRAINING_TEXT: `                    
    <p>To start your campus life, it is important for you to understand that the University’s commitment
      against any form of discrimination including sexual harassment. In order to allow you to gain
      thorough understanding on what conduct constitutes sexual harassment, you are required to
      complete the mandatory "Online training module on Preventing Sexual Harassment on Campus" before
      physically collecting your student ID card.
      <br /><br />
      <u>Please follow the below steps to enroll the online training module via <a
              target="_blank" rel="noopener noreferrer"
              href="https://apc01.safelinks.protection.outlook.com/?url=https%3A%2F%2Flearn.hkmooc.hk%2Faccount%2Ffinish_auth%3Fcourse_id%3Dcourse-v1%253AEOC%252BUGCUOTM%252B2022_Q3_PolyU%26enrollment_action%3Denroll%26email_opt_in%3Dfalse%26course_mode%3Daudit%26tpa_hint%3Dsaml-hkvu-sso&amp;data=05%7C01%7Cwilson-ws.zheng%40polyu.edu.hk%7Cbe3b0cbb6ff748486b1808db87357db1%7C8f37f760b1874981b82fe5dc6f5bcf44%7C0%7C0%7C638252437212114134%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000%7C%7C%7C&amp;sdata=%2BXLYUzEtzKpYDWO6pWkCjW3pNi1MBO1d6Kb8NIjFhfQ%3D&amp;reserved=0"
              originalsrc="https://learn.hkmooc.hk/account/finish_auth?course_id=course-v1%3AEOC%2BUGCUOTM%2B2022_Q3_PolyU&amp;enrollment_action=enroll&amp;email_opt_in=false&amp;course_mode=audit&amp;tpa_hint=saml-hkvu-sso"
              shash="SokvK6hNehXzsDJ+OsvDv3ib2txRhYd8Nu4I+bdic0/+GKLg0sy6NF8XPDa5ShREhHmDuhqaUMU8iJlPN/q5OmetxM2p7gqDvMpJgzPT5X970EJ2kn0WBmEX5yLR3LgBdVV+HwiY4GWxLf8awNSBShQtVNIP+HnsGU52fE9ibhU=">here</a></u>:
      <br /><br />
      Step 1: Click "University Login (via HKAF)" and choose "The Hong Kong Polytechnic University"
      <br /><br />
      Step 2: Login with your student ID (Please make sure that you have already activated your PolyU
      Network Identity (NetID))
      <br /><br />
      Step 3: Create a HKMOOC account
      <br /><br />
      Please reserve sufficient time to complete this online training as it usually takes around 60
      minutes. For enquiry, please call Student Affairs Office at 2766 6800 or email to <a
          href="mailto:diversity.awareness@polyu.edu.hk">diversity.awareness@polyu.edu.hk</a>.
  </p>`,
  MANDATORY_ANTI_DECEPTION_TEXT: `
    <p>You are required to complete the mandatory "Anti-deception Learning Kit" before physically collecting your student ID card.
      <br /><br />
      <u>Please follow the below steps to finish learning Kit via <a
              target="_blank" rel="noopener noreferrer"
              href="https://www40.polyu.edu.hk/poss/secure/login/loginhome.do">here</a></u>:
      <br /><br />
      Step 1: Login with your student ID (Please make sure that you have already activated your PolyU Network Identity (NetID))
      <br /><br />
      Step 2: Click "My profile"
      <img src="/assets/anti-deception-2.png" alt="My profile" width="450" />
      <br />
      Step 3: Click "student survey" under other services[left menu]
      <img src="/assets/anti-deception-3.png" alt="My profile" width="450" />
      <br />
      Step 4: Click the "Anti-deception Learning Kit 2024/2025" in the SAO survey page
       <img src="/assets/anti-deception-4.png" alt="My profile" width="600" />
       <br />
      Step 5: The following page will be shown when all surveys are completed
      <img src="/assets/anti-deception-5.png" alt="My profile" width="600" />
        <br />

      Please reserve sufficient time to complete this online training as it usually takes around 60 minutes. 
      For enquiry, please call Student Affairs Office at 2766 6800 or email to <a
          href="mailto:diversity.awareness@polyu.edu.hk">diversity.awareness@polyu.edu.hk</a>.
  </p>`,
  ENROLMENT_TEXT: `                
    <p>Research students are not allowed to enrol concurrently either on two full-time
        programmes or one full-time programme and one part-time programme, whether or not
        one of the programmes is offered by another institution. Written approval from the Research
        Committee should be obtained before registration in case you wish to enrol concurrently on
        one full-time programme and one part-time programme or more than one part-time programmes,
        including those offered by another institution. Failure to obtain approval may lead to disciplinary
        action including discontinuation of study at PolyU and the tuition fees paid for the programme(s)
        will not be refunded.
        <br /><br />
        Those who wish to apply for concurrent enrolment should download an application for concurrent
        enrolment via
        <a href="https://www.polyu.edu.hk/ar/docdrive/polyu-students/eng-forms/ar38.docx"
            target="_blank">Form AR38</a>
        or get a copy at the Academic Registry Service Centre. Please return the form to the Academic
        Registry before registration on the programme(s) concerned.
        <br /><br />
        Students who have been granted approval for concurrent enrolment should note that the University is
        not responsible for making special timetable arrangement in case of clashes in class and examination
        timetables.
    </p>`,
  HEALTH_CARE_TEXT: `
    <p>Your overall well-being at PolyU is our main focus. Services available to full-time students at the
      University Health Service (UHS) include medical consultations, emergency care, minor operative
      treatments, immunisation, certification on health examinations, nursing care and subsidised primary
      dental care etc. UHS Traditional Chinese Medicine clinic offers general Chinese medicine clinical
      consultations, acupuncture, bone-setting and Chinese medicine granules dispensing service to
      full-time students. To understand more about our services, please visit our website <a
          href="https://www.polyu.edu.hk/uhs/" target="_blank" rel="noopener noreferrer">https://www.polyu.edu.hk/uhs/</a>. Should
      you have any queries, please contact our UHS at 2766 5433 or via e-mail at <a
          href="mailto:uhshelp@polyu.edu.hk">uhshelp@polyu.edu.hk</a>.
  </p>
  `,
  ALUMNI_AFFAIR_TEXT: `
    <p>The Alumni Affairs Office (AAO) is committed to connecting members of the vast PolyU alumni community
        that offers countless resources and engagement opportunities from the moment you set foot on campus as a
        student to the moment you graduate.
    </p>
    <p>Please visit the <a href="http://www.polyu.edu.hk/alumni" target="_blank" rel="noopener noreferrer"><span
                style="font-family:&quot;Arial&quot;,sans-serif">PolyU Alumni
                website</span></a>, which houses all alumni news, stories, events, and links to various social
        media channels. Visit us at the <a target="_blank" rel="noopener noreferrer"
            href="https://www.polyu.edu.hk/alumni/privileges/alumni-atrium/"><span
                style="font-family:&quot;Arial&quot;,sans-serif">Alumni Atrium</span></a> to
        meet with the alumni family, and join alumni associations and networks to connect with your seniors and
        expand your social network.
    </p>
    <p>For assistance, please contact AAO at <a href="mailto:alumni@polyu.edu.hk"><span
                style="font-family:&quot;Arial&quot;,sans-serif">alumni@polyu.edu.hk</span></a>.
    </p>
  `,
  NON_LOCAL_STUDENT_TEXT: `
    <p>Under the Registration of Persons Ordinance, non-local students must apply for an HKID card at the
        Immigration Department within 30 days of arrival
        (please visit <a href="https://www.immd.gov.hk/eng/index.html"
            target="_blank" rel="noopener noreferrer">https://www.immd.gov.hk/eng/index.html</a> for application details). </p>

    <p>
        You are encouraged to utilise the appointment booking and form pre-filling service of the
        Immigration Department via:<br />
        (i) <a target="_blank" rel="noopener noreferrer"
            href="https://www.gov.hk/en/residents/immigration/idcard/hkic/bookregidcard.htm">https://www.gov.hk/en/residents/immigration/idcard/hkic/bookregidcard.htm</a>
        (form pre-filling service available); <br />
        (ii) "HK Immigration Department" Mobile Application (form pre-filling service available); or <br />
        (iii) the 24-hour telephone appointment booking hotline at (852) 2598 0888.
    </p>
    <p>
        There is no charge for HKID card issued to new arrivals. Once you get the HKID card, you are
        entitled to use the government medical services at local rates. You are required to carry your HKID
        card at all times.
    </p>
    <p>
        Upon receipt of the HKID card, it is necessary for you to update your record with PolyU. Please
        complete and return
        <a href="https://www.polyu.edu.hk/ar/docdrive/polyu-students/eng-forms/ar1.doc" target="_blank" rel="noopener noreferrer">Form
            AR1</a>
        in person to the Academic Registry Service Centre (Room M101, Li Ka Shing Tower).
    </p>
  `,
};

export const STUDENT_CARD_BOOKING_TEXT = {
  TIME_SLOT_OPEN_SOON:
    'The booking time slots will open soon. Please check it later.',
  SELECT_PREFERRED_TIME:
    'Please select your preferred time slot for collecting your student ID card on campus:',
  DATE: 'Date',
  AM: 'AM',
  PM: 'PM',
  FULL: 'Full',
  EXPIRED: 'Expired',
  YES: 'Yes',
  CONFIRM: 'Confirm',
  CANCEL: 'Cancel',
  SELECTED_TIME_SLOT: 'Selected time slot:',
  RESCHEDULE: 'Reschedule',
  PICKUP_VENUE_TITLE: 'Pickup Venue: ',
  PICKUP_VENUE_LOCATION:
    'Academic Registry Service Centre, Room M101, 1/F, Li Ka Shing Tower (Block M), The Hong Kong Polytechnic University',
  APPLICANT_NAME: 'Applicant Name',
  STUDENT_NUMBER: 'Student Number',
  CONFIRM_SELECTED_TIME_ALERT: 'Your selected time slot is confirmed.',
  CANCEL_SELECTED_TIME_ALERT: 'Your selected time slot is cancelled.',
  EMAIL_INFO:
    'Please email <u>ar.reg@polyu.edu.hk</u> to schedule a time for picking up your student card.',
  QR_CODE_INFO:
    'The QR code to enter the campus will be sent to your email account shortly.',
  CONFIRM_SELECT_TIME:
    'Are you sure you want to confirm the selected time slot?',
  CANCEL_SELECT_TIME:
    'Are you sure you want to cancel your student card collection reservation?',
  NOTIFICATION: 'Notification',
};

export const CHECK_INFORMATION_TEXT = (isLocal: boolean): string => `
<p class = "text-bottom">The following are some important websites which you may need to refer to during your study at PolyU.
    <i>You
        are advised in particular to read the Student Handbook and <u>check information on your
            <b>subject
                registration and class timetable</b> from eStudent [see item (1) below] before
            commencing
            your
            study and thereafter before each semester.</u></i>
    <br /><br />
</p>

<div class="row con_collapse">
    <div class="col-12">
        <div class="col-lg-12">
            <div class="table-responsive">
                <table class="table" style="width: 100%;">

                    <thead class="header_table text-center">
                        <tr>
                            <th></th>
                            <th>Useful websites</th>
                            <th>URL</th>
                            <th>Information available</th>
                        </tr>

                    </thead>

                    <tbody class="text-center">

                        <tr>
                            <td>(1)</td>
                            <td>eStudent</td>
                            <td><a href="http://www.polyu.edu.hk/student"
                                    target="_blank" rel="noopener noreferrer">http://www.polyu.edu.hk/student</a></td>
                            <td rowspan="2">Update personal particulars, Academic Calendar, Student
                                Handbook<sup>#</sup>, arrangements for subject registration,
                                class/examination timetables, release of assessment results, etc.</td>
                        </tr>

                        <tr>
                            <td>(2)</td>
                            <td>AR Homepage</td>
                            <td><a href="https://www.polyu.edu.hk/ar"
                                    target="_blank" rel="noopener noreferrer">https://www.polyu.edu.hk/ar</a></td>

                        </tr>
                        <tr>
                            <td>(3)</td>
                            <td>Graduate School</td>
                            <td><a href="https://www.polyu.edu.hk/gs/"
                                    target="_blank" rel="noopener noreferrer">https://www.polyu.edu.hk/gs/</a></td>
                            <td>
                                <a href="https://www.polyu.edu.hk/gs/current-students/useful-information-for-new-research-postgraduate-students"
                                    target="_blank" rel="noopener noreferrer">Useful Information for New Research Postgraduate
                                    Students</a>
                            </td>
                        </tr>

                        <tr>
                            <td>(4)</td>
                            <td>Student Account Portal</td>
                            <td><a href="https://www40.polyu.edu.hk/fosae/pages/rologin.jsf"
                                    target="_blank" rel="noopener noreferrer">https://www40.polyu.edu.hk/fosae/pages/rologin.jsf</a>
                            </td>
                            <td class="text-justify">Fee payment matters (including the printing of fee
                                payment receipts, fee
                                payment
                                schedule, checking outstanding fees/refund<sup>*</sup>)</td>
                        </tr>

                        <tr>
                            <td>(5)</td>
                            <td>myPolyU</td>
                            <td><a href="https://my.polyu.edu.hk"
                                    target="_blank" rel="noopener noreferrer">https://my.polyu.edu.hk</a></td>
                            <td>Links to essential systems and websites you need during your study at
                                PolyU; upcoming events and latest themes targeted to students</td>
                        </tr>
                        <tr>
                            <td>(6)</td>
                            <td>IdPortal</td>
                            <td><a href="https://www.polyu.edu.hk/netid"
                                    target="_blank" rel="noopener noreferrer">https://www.polyu.edu.hk/netid</a>
                            </td>
                            <td>View your NetID profile, change/reset your NetPassword
                            </td>
                        </tr>
                        <tr>
                            <td>(7)</td>
                            <td>Student Affairs Office</td>
                            <td><a href="http://www.polyu.edu.hk/sao"
                                    target="_blank" rel="noopener noreferrer">http://www.polyu.edu.hk/sao</a>
                            </td>
                            <td>Links to services and programmes provided by Student Affairs Office
                            </td>
                        </tr>
                        <tr>
                            <td>(8)</td>
                            <td>Student Hall</td>
                            <td><a href="https://www.polyu.edu.hk/sao/student-resources-and-support-section/residential-life/hall-admission/hall-applications/"
                                    target="_blank" rel="noopener noreferrer">https://www.polyu.edu.hk/sao/student-resources-and-support-section/residential-life/hall-admission/hall-applications/</a>
                            </td>
                            <td>Information about student hall application
                            </td>
                        </tr>

                        <tr>
                            <td>(9)</td>
                            <td>English Language Centre</td>
                            <td><a href="https://www.polyu.edu.hk/elc/assessment/rlsa/"
                                    target="_blank">https://www.polyu.edu.hk/elc/assessment/rlsa/</a>
                            </td>
                            <td>Information regarding the Mandatory Research Language Skills Assessment
                                (RLSA)</td>
                        </tr>
                        </tr>
                        <tr>
                            <td>(10)</td>
                            <td>Anti-Telephone Deception</td>
                            <td><a href="https://www.polyu.edu.hk/nlss/living-and-working-in-hong-kong/anti-deception-and-be-cautious-about-high-pressure-groups-or-cults/"
                                    target="_blank" rel="noopener noreferrer">https://www.polyu.edu.hk/nlss/living-and-working-in-hong-kong/anti-deception-and-be-cautious-about-high-pressure-groups-or-cults/</a>
                            </td>
                            <td>Important message about anti-telephone deception</td>
                        </tr>
                        ${
                          !isLocal &&
                          `
                            <tr>
                                <td>(11)</td>
                                <td>Non-local Student Services</td>
                                <td><a href="https://www.polyu.edu.hk/sao/student-resources-and-support-section/non-local-student-services/introduction/"
                                        target="_blank" rel="noopener noreferrer">https://www.polyu.edu.hk/sao/student-resources-and-support-section/non-local-student-services/introduction/</a>
                                </td>
                                <td>Important information on life at PolyU and in Hong Kong for non-local
                                    students</td>
                            </tr>
                            `
                        }
                    </tbody>

                </table>

            </div>
        </div>

    </div>

</div>

<p><sup>#</sup>The Student Handbook contains essential information relevant to your study. Please
    read
    through it, particularly Part C in Section 4 (Use, Access and Change of Student Data); and Section
    11 (Regulations and Rules).
    <br /><br />
    <sup>*</sup>To facilitate refund/scholarship payment from PolyU, please input your bank
    account
    number at this website.
    <br /><br />
    Please refer to the general entitlements on facilities and services available for you at PolyU
    during your study and also upon confirmation of eligibility for graduation as shown in the
    <a href="https://www.polyu.edu.hk/ar/web/en/for-polyu-students/student-handbook/index.html"
        target="_blank" rel="noopener noreferrer">Student Handbook</a> (Section 12 Facilities and Services) and at
    <a href="https://www.polyu.edu.hk/ar/service_provision_graduation"
        target="_blank" rel="noopener noreferrer">https://www.polyu.edu.hk/ar/service_provision_graduation</a> respectively.
    <br /><br />
    You can also find the websites of other PolyU offices at the University Homepage (<a
        href="http://www.polyu.edu.hk" target="_blank" rel="noopener noreferrer">http://www.polyu.edu.hk</a>).
</p>
`;

export const WELCOME_PERORATION = `
<p>We wish you every success in your study and a happy university life!</p>
<p>Graduate School</p>
<br />
`;

export const COLLECT_IDENTITY_CARD_TEXT = (isLocal: boolean): string => `
<p>The diagram below shows the workflow for student identity card collection, please <u><b>follow the
            steps below to book a timeslot for collection of your student identity card</b></u>.</p>
<img src="https://www.polyu.edu.hk/aradm/prog_reg/SID_collection_diagram.jpg"
    alt="Student Card Workflow" width="1200" height="300" />
<br />
<p>
    <div><b>Steps to Collect Your Student Identity Card</b></div>
    <br />

    <div><b>1. Activate Your PolyU Network Identity (NetID)</b> </div>
    <div>
    &nbsp;&nbsp;&nbsp;&nbsp;Visit <a href="https://my.polyu.edu.hk"
        target="_blank" rel="noopener noreferrer">https://my.polyu.edu.hk</a> to activate your NetID. If this has not been completed, please refer to the initial part of your welcome letter for guidance.
    </div>
    <br />

    <div><b>2. Complete the Online Surveys and Mandatory Online Training</b></div>
    <div>&nbsp;&nbsp;&nbsp;&nbsp;Please ensure that the <a>Online Surveys</a> and <a>Mandatory Online Training</a> are completed through the provided link. (Plz insert the links for these two tasks.) </div>
    <br />

    <div><b>3. Book or Modify a Student Identity Card Collection Timeslot</b></div>
    <div>&nbsp;&nbsp;&nbsp;&nbsp;After completing the steps above, please go to Section C “Student Card Collection Booking” to book or update your timeslot for collecting your student identity card. </div>
    <br />

    <div><b>4. Receive a QR Access Code via Email to Enter PolyU Campus</b></div>
    <div>
    &nbsp;&nbsp;&nbsp;&nbsp;Once you’ve booked your timeslot, a QR access code will be sent to your PolyU Connect email account. This code will grant access to the campus.
    </div>
    <br />

    <div><b>5. Collect Student Identity Card on Campus</b></div>
    <div>
    &nbsp;&nbsp;&nbsp;&nbsp;On the scheduled date, scan the QR code at the campus entrance. Ensure you also bring your <b>Notice of Offer/Welcome Letter</b> and a <b>valid personal identity document</b> for access verification.
    </div>
    <br />

</p>

<p><b>You are required to complete the below items before collecting your student identity card:</b>
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;1. Complete the survey in RPgAdmission.
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;2. Complete the mandatory "Online training module on Preventing Sexual
    Harassment on Campus" before collecting your student ID card, please refer to the above session.
    <br />
    ${
      !isLocal &&
      `
        &nbsp;&nbsp;&nbsp;&nbsp;3. Upload your landing slip (<a
        href="https://www.polyu.edu.hk/ar/docdrive/polyu-students/visa-matters/Sample_Landing-Slip.pdf"
        target="_blank" rel="noopener noreferrer">sample</a>) and input the visa expiry date via <a
        href="https://www38.polyu.edu.hk/eStudent/" target="_blank" rel="noopener noreferrer"
        title="https://www38.polyu.edu.hk/estudent/">eStudent</a> (Home &gt; My Profile &gt; Personal
        Details &gt; Visa matters for Non-Local Students).
        `
    }

</p>
<p><b>Student identity card will be printed and issued to you after verifying the following original
        documents on the spot:</b>
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;- your personal identity document (e.g. passport, national identity card)
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;- visa-related documents (i.e. e-visa and landing slip) for non-Hong Kong
    permanent residents
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;- Exit Endorsement D (逗留D), Mainland identity card, and Exit-entry Permit
    for traveling to and from Hong Kong and Macao (EEP ,往來港澳通行證) for students from Mainland China only.
</p>
`;

export const CREATE_STUDENT_RECORD_UNAVAILABLE = `<p><span style="color:red"><b>Currently unavailable for online 
registration. We will inform you once it becomes available.</b></span></p>`;

export const ONLINE_TRAINING = {
  STATUS: 'Status: ',
  COMPLETED: 'Completed',
  NOT_COMPLETED: 'Incomplete',
  NOT_REQUIRED: 'Not Required',
  REQUIRED_COMPLETE: `You are required to complete the following online training modules and survey(s) before booking a timeslot to collect your student ID card.`,
  MODULES: [
    'Anti-deception Learning Kit',
    'Preventing Sexual Harassment on Campus (A) to (D)',
    'Depression, Anxiety and Stress Scales (DASS)',
  ],
  ENROLL_STEPS: [
    `It will take approximately one hour to complete all online training modules and survey(s). However, you may complete them on a part-by-part basis.`,
    `Please ensure that you have a reliable internet connection and complete each module once you have started. Otherwise, you will have to start the module from the beginning again. The default timeout is set to 2 hours.`,
    `Click “Play YouTube Video” (or “播放視頻”) to play or pause the video in the Anti-Deception Learning Kit. The video is compulsory and CANNOT be skipped. Additionally, the system DOES NOT allow you to fast forward or rewind the video. Do not quit the page, or you will have to watch the video from the beginning.`,
    `The progress bar indicates the completion status of the modules only. Hence, it will not move while the video is playing.`,
    `You must click <b>“SUBMIT”</b> to complete each module/survey. Then you may return to the checklist by clicking “Back to Home”.`,
    `Once you have finished a module/survey, a “✓” will appear next to the checklist. The module/survey will no longer be accessible after completion.`,
    `When all questions of the training modules/survey(s) are completed, you could return to the checklist by clicking “Back to Home”.`,
    `For enquiries, please contact SAO via <span style="color:#ff0000;">sao.ovts@polyu.edu.hk</span> or 852-2766 6800.`,
  ],
};

export const ONLINE_TRAINING_ENROLL_LINK = (link: string): string => `
  Please enroll the online training module via <b><a target="_blank" rel="noopener noreferrer" href="${link}" style="color:#ff0000; text-decoration: underline;">here</a></b>:  
`;
